module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "wrapper wrapper-content h100pp",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "float-e-margins ibox-content animated fadeInRight h100pp"
  }, [_c('div', {
    staticClass: "row h100pp"
  }, [_c('div', {
    staticClass: "form-horizontal h100pp"
  }, [_c('div', {
    staticClass: "col-sm-3 gray_right02 h100pp mt50px"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addNewVersion
    }
  }, [_vm._v("新增")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.deleteBtn
    }
  }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-offset-1 w200px text-center mt30px"
  }, _vm._l((_vm.versionArr), function(item, index) {
    return _c('button', {
      staticClass: "btn col-sm-10 h40px btn-primary js-select",
      on: {
        "click": function($event) {
          return _vm.selectBtn($event, index)
        },
        "mouseover": _vm.mouseOver
      }
    }, [_vm._v(_vm._s(item.udcName))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 gray_left02 h100pp"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 h100pp mt50px"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("版本名称")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVersion.udcName),
      expression: "editVersion.udcName"
    }],
    staticClass: "form-control menuInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editVersion.udcName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVersion, "udcName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("版本号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVersion.licId),
      expression: "editVersion.licId"
    }],
    staticClass: "form-control menuInput",
    attrs: {
      "type": "text",
      "disabled": this.type == 'editVersionType'
    },
    domProps: {
      "value": (_vm.editVersion.licId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVersion, "licId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 h100pp mt30px"
  }, [_c('div', {
    staticClass: "col-sm-6 h100pp"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "col-sm-offset-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.confirmBtn
    }
  }, [_vm._v("保存")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 gray_left02 h100pp"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "height": "600px"
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("备注")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVersion.udcText),
      expression: "editVersion.udcText"
    }],
    attrs: {
      "name": "",
      "rows": "10",
      "cols": "35"
    },
    domProps: {
      "value": (_vm.editVersion.udcText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVersion, "udcText", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.type == 'editVersionType') ? _c('div', {
    staticClass: "col-sm-12  mt30px"
  }, [_c('div', {
    staticClass: "col-sm-12 text-left mt30px"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isUser),
      expression: "isUser"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isUser) ? _vm._i(_vm.isUser, null) > -1 : (_vm.isUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isUser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isUser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isUser = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("将本次变更的功能反映到操作员")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-left"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCustomer),
      expression: "isCustomer"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCustomer) ? _vm._i(_vm.isCustomer, null) > -1 : (_vm.isCustomer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isCustomer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCustomer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCustomer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCustomer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("将本次变更的功能反映到下级所有组织机构")])])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])])])])])]), _vm._v(" "), _c('sub-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "title": "提示"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.messageStr) + "\n\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeSub('modalMsg')
      }
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('sub-modal', {
    ref: "deleteMsg",
    attrs: {
      "size": "small",
      "title": "提示"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.messageStr) + "\n\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary mr10px",
    on: {
      "click": function($event) {
        return _vm.closeSub('deleteMsg')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.removeVersion()
      }
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10",
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "id": "ibox-content"
    }
  }, [_c('ul', {
    staticClass: "ztree",
    staticStyle: {
      "height": "600px",
      "width": "350px"
    },
    attrs: {
      "id": "jurisdictionTree"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "col-sm-offset-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg"
  }, [_vm._v("取消")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66654b58","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/versioning/PageVersioning.vue
// module id = 1548
// module chunks = 0